import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2533f368"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "technology",
  class: "row m-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-3 mt-5 ms-5 fw-bold text-start text-primary" }, "Technical Skill Set"),
  /*#__PURE__*/_createElementVNode("h6", { class: "fs-2 text-start ms-5 mt-3 lh-sm" }, "We have experience with many frameworks, languages, and tools, and we can assemble the perfect set for your project. Here are some of the ones we use often.")
], -1))
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-xs-4 col-4",
            key: skill.id
          }, [
            _createElementVNode("img", {
              src: skill.imageUrl,
              alt: skill.description,
              class: "skill-logo p-1 my-3"
            }, null, 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ]))
}